var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: _vm.controlsType === "add" ? "新增通用活动" : "编辑通用活动",
            visible: _vm.dialogVisible,
            width: "650px",
            "before-close": _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "content_box" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "平台类型", prop: "region" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "420px" },
                          attrs: { placeholder: "请选择平台类型" },
                          model: {
                            value: _vm.ruleForm.region,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "region", $$v)
                            },
                            expression: "ruleForm.region",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "淘宝", value: "TB" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "京东", value: "JD" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "抖音", value: "DY" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "拼多多", value: "PDD" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "唯品会", value: "WPH" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "美团", value: "MT" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动名称", prop: "name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "420px" },
                        attrs: { placeholder: "请输入活动名称" },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "背景色值" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "420px" },
                        attrs: { placeholder: "请输入背景色值" },
                        model: {
                          value: _vm.ruleForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "color", $$v)
                          },
                          expression: "ruleForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "链接类型", prop: "type" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "type", $$v)
                            },
                            expression: "ruleForm.type",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 0 },
                              model: {
                                value: _vm.ruleForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "type", $$v)
                                },
                                expression: "ruleForm.type",
                              },
                            },
                            [_vm._v("活动ID")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.ruleForm.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "type", $$v)
                                },
                                expression: "ruleForm.type",
                              },
                            },
                            [_vm._v("链接URL")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "id" } },
                    [
                      _vm.ruleForm.type === 0
                        ? _c("el-input", {
                            staticStyle: { width: "420px" },
                            attrs: { placeholder: "请输入活动ID" },
                            model: {
                              value: _vm.ruleForm.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "id", $$v)
                              },
                              expression: "ruleForm.id",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.ruleForm.type === 1
                        ? _c("el-input", {
                            staticStyle: { width: "420px" },
                            attrs: { placeholder: "请输入活动URL" },
                            model: {
                              value: _vm.ruleForm.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "id", $$v)
                              },
                              expression: "ruleForm.id",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "推广素材文案：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "420px" },
                        attrs: { placeholder: "请输入素材文案" },
                        model: {
                          value: _vm.ruleForm.promoteDesc,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "promoteDesc", $$v)
                          },
                          expression: "ruleForm.promoteDesc",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动页头图：", prop: "" } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100px",
                            height: "100px",
                            background: "#f9f9f9",
                            "border-radius": "4px",
                            border: "1px solid #eeeeee",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              staticClass: "avatar-uploader",
                              attrs: {
                                "show-file-list": false,
                                "on-success": _vm.handleAvatarSuccess,
                                action: "",
                                "http-request": _vm.handleFileUpload,
                              },
                            },
                            [
                              _vm.ruleForm.imageUrl
                                ? _c("img", {
                                    staticClass: "avatar",
                                    attrs: { src: _vm.ruleForm.imageUrl },
                                  })
                                : _c("i", {
                                    staticClass:
                                      "el-icon-plus avatar-uploader-icon",
                                  }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "活动时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options": _vm.pickerOptions,
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "default-time": ["12:00:00"],
                        },
                        model: {
                          value: _vm.ruleForm.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "date", $$v)
                          },
                          expression: "ruleForm.date",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#F59A23",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            "请选择活动时间（未选择时间时默认为长期有效状态）"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer fc",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "found",
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "reset",
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("ruleForm")
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }